import {ReportExecutionSearchComponent} from './report-execution-search.component';
import {ReportExecutionSearchGuard} from './_guards';
export const ReportExecutionRoutes = [
  {
    path: 'report-execution-search',
    component: ReportExecutionSearchComponent,
    canActivate: [ReportExecutionSearchGuard],
  },
];
